import * as React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.farmerCode}
        </TableCell>
        <TableCell align="left">{row.farmerName}</TableCell>
        <TableCell align="left">{row.workingArea}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Status Kegiatan</TableCell>
                    <TableCell>Tanggal Kegiatan</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell component="th" scope="row">
                     Mengisi Kegiatan
                    </TableCell>
                    <TableCell>
                        {
                            row.activityDates.length > 0 ?
                            row.activityDates.map((item, index) => {
                                return (
                                    <div key={index}>
                                        {item}
                                    </div>
                                )
                            }) : 
                            <p>Data Kosong</p>
                        }
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row">
                     Tidak Mengisi Kegiatan
                    </TableCell>
                    <TableCell>
                        {
                            row.noActivityDates.length > 0 ?
                            row.noActivityDates.map((item, index) => {
                                return (
                                    <div key={index}>
                                        {item}
                                    </div>
                                )
                            }) : 
                            <p>Data Kosong</p>
                        }
                    </TableCell>
                  </TableRow>
               
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

Row.propTypes = {
  row: PropTypes.object,
};

export default function SpvReportDailyActivityTable({ data }) {
  return (
    <TableContainer component={Paper}>
      <Table aria-label="collapsible table">
        <TableHead style={{background: '#499178'}}>
          <TableRow style={{color: 'white'}}>
            <TableCell />
            <TableCell style={{color: 'white'}}>Kode</TableCell>
            <TableCell style={{color: 'white'}} align="left">Nama</TableCell>
            <TableCell style={{color: 'white'}} align="left">Area</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, index) => (
            <Row key={index} row={row} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

SpvReportDailyActivityTable.propTypes = {
  data: PropTypes.array,
};
